import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { HexonProvider } from "../../providers/hexon/hexon";
import { Observable, Subject } from "rxjs";
import { IAdSite, IAdSiteDetails } from "../../models/site";
import { RefreshProvider } from "../../providers/refresh/refresh";

@Component({
  selector: "page-new-link",
  templateUrl: "new-link.html",
})
export class NewLinkPage {
  public allAccounts$: Observable<IAdSite[]>;
  public selectedAccount$: Observable<IAdSiteDetails>;
  public selectedAccountCode: string;
  public confirmed = false;
  public reload: () => {};

  private selectedAccountCodeSubject$ = new Subject<string>();

  constructor(
    private navCtrl: NavController,
    private hexon: HexonProvider,
    private refresh: RefreshProvider,
    /* tslint:disable:no-unused-variable */
    private params: NavParams
  ) {
    this.allAccounts$ = Observable.combineLatest(
      hexon.getAllSites$(),
      hexon.getAccounts$()
    ).map(([sites, accounts]) =>
      sites.data[0].results
        // Filter sites you are already signed up to
        .filter((site) =>
          accounts.every((account) => account.site_code !== site.code)
        )
        .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
    );

    this.selectedAccount$ = this.selectedAccountCodeSubject$
      .switchMap((selectedAccountCode) => hexon.getSite$(selectedAccountCode))
      .map((result) => {
        const adSiteDetail = result.data[0].results[0];
        // Filter 'test' subdomain to show images on test environment
        if (adSiteDetail && adSiteDetail.logo_url) {
          adSiteDetail.logo_url = adSiteDetail.logo_url.replace(/test\./, "");
        }
        return adSiteDetail;
      });

    this.reload = params.get("reload");
  }

  public async newLink() {
    await this.hexon
      .activate$(this.selectedAccountCode)
      .first()
      .toPromise();
    this.refresh.setDirty();
    this.navCtrl.pop();
    this.reload();
  }

  public cancel() {
    this.navCtrl.pop();
  }

  public changeAccount() {
    this.selectedAccountCodeSubject$.next(this.selectedAccountCode);
  }
}



// WEBPACK FOOTER //
// ./src/pages/new-link/new-link.ts